/** Admin: an owner's API keys + limit override (OwnerScopeProvider twin). */
import React from 'react';
import { useLocalSearchParams } from 'expo-router';
import { OwnerScopeProvider } from '../../../../src/context/OwnerScopeContext';
import ApiAccessScreen from '../../../../src/screens/ApiAccessScreen';
export default function AdminOwnerApiAccess() {
  const { id } = useLocalSearchParams<{ id: string }>();
  return <OwnerScopeProvider ownerId={id ?? null}><ApiAccessScreen adminOwnerId={id} /></OwnerScopeProvider>;
}
